import CartUpsellProduct from '@components/Product/CartUpsellProduct.jsx'

const CartUpsell = ({ upsellData }) => {
    // console.log('upsellData', upsellData)
    let title = upsellData.title || 'Related Items'

    const products = upsellData.products.slice(0, 4)

    return (
        <div className='cart-upsell-outer pb-12'>
            <div className='cart-upsell-inner px-4 flex flex-col items-center justify-center'>
                <h3 className='text-lg font-medium mb-2'>{title}</h3>
                <div className='cart-upsell-products grid grid-cols-2 gap-4'>
                    {products.map((product) => {
                        return (
                            <CartUpsellProduct
                                key={product.id}
                                product={product}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
export default CartUpsell
